export enum ForgetPasswordView {
  USER_FORM = "USER_FORM",
  CODE_FORM = "CODE_FORM",
  PASSWORD_FORM = "PASSWORD_FORM",
  PASSWORD_CHANGED = "PASSWORD_CHANGED",
}
